import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import CallIcon from '@mui/icons-material/Call'
import BookAppointmentDialog from './BookAnAppointmentDialogue'
import amsrish from "../assets/DocImages/amrishsir.jpg"
import sindhu from "../assets/DocImages/Dr Swetha Kodali.jpg"
import mahinder from "../assets/DocImages/mahendra.jpeg"
import shape from "../assets/Images/shapes/Thred 03-01.png"
import shape2 from "../assets/Images/shapes/Thred 04-01.png"
export default function AboutTeam() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  return (
    <div>
      <div className='max-w-[1340px] mx-auto relative'>
        <div
          className='relative bg-verylightGreen rounded-[24px] p-[25px_24px_24px] md:p-[180px_40px_224px] bg-no-repeat'>
          <div className='absolute top-0 left-0'>
            <img src={shape2} className='md:w-[300px] w-28' alt='shape'/>
          </div>
          <div className='absolute bottom-0 right-0'>
            <img src={shape} className='w-[300px]' alt='shape'/>
          </div>
          <div className='w-full lg:w-[626px] mx-auto' data-aos="fade-down">
            <div className='text-center mb-[56px]'>
              <h2 className='text-thickGreen text-[36px] lg:text-[58px] leading-[1.138em] font-heading mb-[24px]'>
                Meet the Trusted MagnAid Expert’s Team
              </h2>
              <div>
                <p className='text-[18px] leading-[1.667em] text-paraGreen font-medium'>
                  Our trusted and highly skilled professionals are dedicated to provide the advanced care with utmost compassionate approach precisely tailored to meet each patient’s need.
                </p>
              </div>
            </div>
          </div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={4} className='max-w-[1126px] mx-auto'>
              <Grid size={{ xs: 12, md: 4 }}>
                <div className='p-[52px_32px_64px] bg-lightOrange rounded-[24px]' data-aos="zoom-in">
                  <div className='flex justify-center'>
                    <Link
                      to=''
                      className='block w-[200px] h-[200px] rounded-full overflow-hidden mb-[24px]'
                    >
                      <img
                        src={amsrish}
                        alt='Dr. Sidda Amrish Ram Reddy'
                        className='w-full h-full object-cover transition-transform duration-300 hover:scale-110'
                        loading='eager'
                        sizes='(max-width: 767px) 140px, 200px'

                      />
                    </Link>
                  </div>
                  <div className='block xl:flex justify-between gap-[16px]'>
                    <div>
                      <h3 className='text-[22px] mb-[6px] leading-[1.273em] font-heading font-medium text-thickGreen'>
                        Dr. Sidda Amrish Ram Reddy
                      </h3>
                      <div className='text-[18px] leading-[1.111em] font-medium text-orange font-body '>
                        General Surgeon
                      </div>
                    </div>
                    <div className='flex gap-[16px] mt-8 xl:mt-0'>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <AddIcon />{' '}
                      </Link>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <CallIcon />{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <div className='p-[52px_32px_64px] bg-lightOrange rounded-[24px]' data-aos="zoom-in">
                  <div className='flex justify-center'>
                    <Link
                      to=''
                      className='block w-[200px] h-[200px] rounded-full overflow-hidden mb-[24px]'
                    >
                      <img
                        src={sindhu}
                        loading='eager'
                        alt='Dr. Sophie Moore'
                        sizes='(max-width: 767px) 140px, 200px'
                        className='w-full h-full object-cover transition-transform duration-300 hover:scale-110'
                      />
                    </Link>
                  </div>
                  <div className='block xl:flex justify-between gap-[16px] '>
                    <div>
                      <h3 className='text-[22px] mb-[6px] leading-[1.273em] font-heading font-medium text-thickGreen'>
                        Dr. Sindhu Kodali
                      </h3>
                      <br></br>
                      <div className='text-[18px] leading-[1.111em] font-medium text-orange font-body '>
                        Gynecologist
                      </div>
                    </div>
                    <div className='flex gap-[16px] mt-8 xl:mt-0'>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <AddIcon />{' '}
                      </Link>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <CallIcon />{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <div className='p-[52px_32px_64px] bg-lightOrange rounded-[24px]' data-aos="zoom-in">
                  <div className='flex justify-center'>
                    <Link
                      to=''
                      className='block w-[200px] h-[200px] rounded-full overflow-hidden mb-[24px]'
                    >
                      <img
                        src={mahinder}
                        loading='eager'
                        alt='Dr. Matt Cannon'
                        sizes='(max-width: 767px) 140px, 200px'
                        className='w-full h-full object-cover transition-transform duration-300 hover:scale-110'
                      />
                    </Link>
                  </div>
                  <div className='block xl:flex  justify-between gap-[16px]'>
                    <div>
                      <h3 className='text-[22px] mb-[6px] leading-[1.273em] font-heading font-medium text-thickGreen'>
                        Dr. Mahendra Biradar
                      </h3>
                      <div className='text-[18px] leading-[1.111em] font-medium text-orange font-body '>
                        Pulmonologists
                      </div>
                    </div>
                    <div className='flex gap-[16px] mt-8 xl:mt-0'>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <AddIcon />{' '}
                      </Link>
                      <Link className='flex justify-center items-center rounded-full border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent transition-all duration-300 hover:bg-lightGreen hover:text-white hover:border-none w-16 h-16 text-[26px] sm:w-10 sm:h-10 sm:text-[22px]'>
                        <CallIcon />{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
          <div className='sm:block md:flex justify-center md:space-x-4 space-y-4 md:space-y-0 mt-[48px]' data-aos="fade-up">
            <button
              onClick={handleOpenDialog}
              className='bg-orange text-white p-[24px_38px] rounded-full   font-body text-[20px] leading-[1.112em] 
                 transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 
                 hover:translate-y-[-3px] block md:inline-block text-center font-medium  w-full md:w-[275px] mr:0 md:mr-[24px]'
            >
              Book an Appointment
            </button>
            <Link
              to='/our-medical-services'
              className='text-thickGreen px-12 py-5 rounded-full font-medium border w-full md:w-[275px] border-thickGreen bg-transparent md:flex justify-center items-center 
                 hover:bg-orange hover:text-white hover:border-none text-[20px] leading-[1.112em]  transition-all duration-300 hover:translate-y-[-3px] 
                 block sm:inline-block text-center font-body'
            >
              Our Specialities
            </Link>
          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
